
import { Component, Mixins, Prop } from "vue-property-decorator";
import { IFreeInputable, IRuleInjectable } from "../../../../../domain/document/items";
import { IFreeInputableWrappedObject } from "../IFreeInputableWrappedObject";

@Component
export default class FreeInputableMixin extends Mixins() implements IFreeInputableWrappedObject {
  @Prop()
  shouldInputFreeAll: boolean;

  readPropertyOrDefault: <T>(reader: (source: IFreeInputable & IRuleInjectable) => T, defaultValue: T) => T;
  writePropertyWhenValid: (writer: (source: IFreeInputable & IRuleInjectable) => void) => void;

  get isFreeInputable(): boolean {
    return this.readPropertyOrDefault(s => s.isFreeInputable && !(s.injectedRule && s.injectedRule.isEditDisabled), undefined);
  }

  get shouldInputFree(): boolean {
    return this.readPropertyOrDefault(s => s.shouldInputFree && !(s.injectedRule && s.injectedRule.isEditDisabled), undefined);
  }

  set shouldInputFree(value: boolean) {
    if (this.shouldInputFree === value) {
      return;
    }
    this.writePropertyWhenValid(s => s.shouldInputFree = value);
  }

  get shouldInputFreeSelfOrAll(): boolean {
    return this.shouldInputFree || (this.isFreeInputable && this.shouldInputFreeAll);
  }

  get isFreeInputOverwrittenByAll(): boolean {
    return !this.shouldInputFree && this.shouldInputFreeSelfOrAll;
  }

  get isEditDisabledByRuleSet(): boolean {
    return this.readPropertyOrDefault(s => !!s.injectedRule && s.injectedRule.isEditDisabled, undefined);
  }
}
